<template>
  <div class="container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <div class="three-a-row" v-if="config.enableOut" style="margin-top: 8px">
            <div class="nav-title">支出类型</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of payTypeList" :key="item.id">
                <div
                  class="item-nav van-ellipsis"
                  :class="{ active: params.payAccountTypeIds.indexOf(item.id) > -1 }"
                  @click="triggerPayOut(item)"
                >
                  {{ item.accTypeName }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="config.enableIn" style="margin-top: 8px">
            <div class="nav-title">收入类型</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of incomeTypeList" :key="item.id">
                <div
                  class="item-nav van-ellipsis"
                  :class="{ active: params.incomeAccountTypeIds.indexOf(item.id) > -1 }"
                  @click="triggerIncome(item)"
                >
                  {{ item.accTypeName }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm"> 确定 </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
let defaultParams = {
  // 选中的支出类型
  payAccountTypeIds: [],
  payAccountTypeList: [],
  // 选中的收入类型
  incomeAccountTypeIds: [],
  incomeAccountTypeList: [],
};

export default {
  name: 'accountbook-filter',
  data() {
    return {
      visible: false,
      // 支出类型列表
      payTypeList: [],
      // 收入类型列表
      incomeTypeList: [],
      config: {
        enableIn: true,
        enableOut: true,
      },
      params: JSON.parse(JSON.stringify(defaultParams)),
    };
  },
  computed: {},
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;

        if (opts.config) {
          this.config = Object.assign(this.config, opts.config);
        }
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 支出
    triggerPayOut(item) {
      let i = this.params.payAccountTypeIds.indexOf(item.id);
      if (i === -1) {
        this.params.payAccountTypeIds.push(item.id);
        this.params.payAccountTypeList.push(item);
      } else {
        this.params.payAccountTypeIds.splice(i, 1);
        this.params.payAccountTypeList.splice(i, 1);
      }
    },
    // 收入
    triggerIncome(item) {
      let i = this.params.incomeAccountTypeIds.indexOf(item.id);
      if (i === -1) {
        this.params.incomeAccountTypeIds.push(item.id);
        this.params.incomeAccountTypeList.push(item);
      } else {
        this.params.incomeAccountTypeIds.splice(i, 1);
        this.params.incomeAccountTypeList.splice(i, 1);
      }
    },
    // 重置
    reset() {
      let resetParams = {};
      if (this.config.enableIn) {
        resetParams.incomeAccountTypeIds = [];
        resetParams.incomeAccountTypeList = [];
      }
      if (this.config.enableOut) {
        resetParams.payAccountTypeIds = [];
        resetParams.payAccountTypeList = [];
      }
      this.params = resetParams;
    },
    doneAnima() {
      this.$router.back();
      return new Promise(rsv => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: this.params,
          })
        )
      );
    },
    // 获取类型数据
    getType() {
      this.$api.getAccountType().then(res => {
        if (res.code === 200) {
          this.payTypeList = res.data.payTypeList;
          this.incomeTypeList = res.data.incomeTypeList;
        }
      });
    },
  },
  created() {
    this.prevInit();
    this.getType();
  },
  beforeDestroy() {},
  watch: {
    '$vxRoute.vx_action': function (nv, ov) {
      if (nv == 'vx-out') {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;

    }
  }
}
</style>